import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { LogOut, CheckCircle2, AlertTriangle } from "lucide-react";

export default function LogoutPage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("info"); // <-- fixed
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (status === "success") {
      setShowAlert(true);
      setAlertType("success");
      setAlertMessage("You’ve been logged out successfully.");
    } else if (status === "failed") {
      setShowAlert(true);
      setAlertType("error");
      setAlertMessage(
        "Logout failed. Please try again or contact support if the issue persists."
      );
    } else {
      setShowAlert(false);
      setAlertType("info");
      setAlertMessage("");
    }
  }, [status]);

  const alertStyles =
    alertType === "success"
      ? "bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200"
      : alertType === "error"
      ? "bg-rose-50 text-rose-800 ring-1 ring-rose-200"
      : "bg-slate-50 text-slate-700 ring-1 ring-slate-200";

  const alertIcon =
    alertType === "success" ? (
      <CheckCircle2 className="h-5 w-5 flex-none" aria-hidden="true" />
    ) : alertType === "error" ? (
      <AlertTriangle className="h-5 w-5 flex-none" aria-hidden="true" />
    ) : null;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-slate-200 bg-white/90 backdrop-blur-sm shadow-xl">
          <div className="p-8">
            {/* Brand */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-xl bg-slate-900 flex items-center justify-center shadow-sm">
                  <span className="text-white font-semibold">GG</span>
                </div>
                <div>
                  <h1 className="text-xl font-semibold text-slate-900 tracking-tight">
                    Gentle-Gourmet
                  </h1>
                  <p className="text-sm text-slate-500">See you again soon.</p>
                </div>
              </div>
              <LogOut className="h-6 w-6 text-slate-400" aria-hidden="true" />
            </div>

            {/* Alert */}
            {showAlert && (
              <div
                role="status"
                className={`mb-6 flex items-start gap-3 rounded-xl px-4 py-3 ${alertStyles}`}
              >
                <span className="mt-0.5">{alertIcon}</span>
                <p className="text-sm leading-6">{alertMessage}</p>
              </div>
            )}

            {/* CTA */}
            <Link
              to="/login"
              className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-3 text-sm font-medium text-white transition-all hover:bg-slate-800 active:scale-[0.99]"
            >
              Log In Again
              <LogOut className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
